// extracted by mini-css-extract-plugin
export default {"formHolder":"File_formHolder__wq9xh","btnHolder":"File_btnHolder__ks+js","filesModalHolder":"File_filesModalHolder__s-DQz"};